import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";

import * as getters from "./getters";

import surveystate from "./modules/surveystate";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: true,
    getters,
    modules: {
        app,
        surveystate
    },
    state: {
        modal: {
            status: false,
            message: ""
        }
    },
    mutations: {
        setModalState(state, { status, message }) {
            state.modal = {
                status: status,
                message: message
            };
        }
    }
});


export default store;